/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Willexpiresuffix2Inputs */

const zh_subscription_willexpiresuffix2 = /** @type {(inputs: Subscription_Willexpiresuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到期`)
};

const en_subscription_willexpiresuffix2 = /** @type {(inputs: Subscription_Willexpiresuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_subscription_willexpiresuffix2 = /** @type {(inputs: Subscription_Willexpiresuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

/**
* | output |
* | --- |
* | "" |
*
* @param {Subscription_Willexpiresuffix2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_willexpiresuffix2 = /** @type {((inputs?: Subscription_Willexpiresuffix2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Willexpiresuffix2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_willexpiresuffix2(inputs)
	if (locale === "en") return en_subscription_willexpiresuffix2(inputs)
	return es_subscription_willexpiresuffix2(inputs)
});
export { subscription_willexpiresuffix2 as "subscription_willExpireSuffix" }